require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-manila-street-astronomers-and-spiderman.json") })
        }
      }, "path---blog-the-manila-street-astronomers-and-spiderman");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-manila-street-astronomers-and-spiderman!./.cache/json/blog-the-manila-street-astronomers-and-spiderman.json
// module id = 385
// module chunks = 231608221292675